<template>
  <div class="reset-friend-list">
    <div class="search-title">
      <span class="fa fa-search" @click="searchResetFriends($event)"></span>
      <input-control
        v-model="searchTextResetFriendsInput"
        type="text"
        :no-title="true"
        name="search_title"
        @keypress="onEnter($event, searchResetFriends)"
        :placeholder="$t('column.nm.nm')"
        :class="{'search-title-text': true}"
      />
    </div>
    <div class="sorting-area">
      <span :class="{'sort-item': true, 'selected': resetFriendsOrder === 'nm'}" @click="clickResetFriendsOrder('nm', $event)">{{ $t('reset.sort.title') }} <span><i :class="'fa fa-play ' + resetFriendsDirection" /></span></span>
    </div>
    <div class="reset-friends-list-container" @scroll="onScrollResetFriends">
      <div v-if="resetFriendsTotal === 0" class="no-data">
        {{ $t('common.text.no_data') }}
      </div>
      <div v-else class="reset-friends-list-wrapper">
        <div v-for="(resetFriend, resetFriendIndex) in resetFriends" :key="'reset-friend-' + resetFriendIndex" class="reset-friend-item" @click="selectResetFriend(resetFriend, $event)">
          <div class="profile-image-area">
            <div :class="{'profile-image-container': true, 'no-default-image': resetFriend.partner.thumbs && resetFriend.partner.thumbs.length > 0}">
              <centered-image :src="getImgUrl(resetFriend.partner.thumbs, undefined, undefined, undefined, undefined, '/img/gnb/empty_profile.png')" :alt="resetFriend.partner.nm" :cover="true" default-image-url="/img/gnb/empty_image.png" />
            </div>
          </div>
          <div class="partner-name-and-telno">
            <div class="partner-name">
              {{ resetFriend.partner.nm }}
              <span v-if="resetFriend.partner.usanaGradCode">
                {{ $t('code.nm.' + resetFriend.partner.usanaGradCode) }}
              </span>
            </div>
            <div v-if="resetFriend.partner.mobile" class="partner-telno">
              {{ resetFriend.partner.mobile }}
            </div>
          </div>
          <div class="control-area">
            <button class="btn btn-delete-friend" @click="deleteFriendConfirm(resetFriend, $event)">
              {{ resetFriend.sttusCode==='friend_status.requested' ? $t('reset.button.cancel_friend_request') : $t('reset.text.delete_friend') }}
            </button>
            <div v-if="resetFriend.sttusCode==='friend_status.requested'" class="friend-status">
              {{ $t('reset.text.requesting_friend') }}
            </div>
          </div>
        </div>
        <div class="clear" />
        <div v-if="resetFriendsTotal !== undefined && resetFriendsTotal > resetFriendsLoaded" class="reset-friends-loading resets-loading">
          <div class="clear" />
          <img src="/img/ajax-loader-white-bg.gif" alt="Loading">
          <strong>{{ $t('common.text.loading') }}</strong>
        </div>
      </div>
    </div>
    <div class="controls bottom-fixed-controls">
      <div class="button-area">
        <button class="btn no-border" @click="showRequestFriendsModal($event)">
          {{ $t('reset.text.request_friend') }}
        </button>
      </div>
      <div lass="button-area">
        <button class="btn no-border" :disabled="resetFriendRequests.length === 0" @click="showAcceptFriendsModal($event)">
          {{ $t('reset.text.accept_friend') }}
          <span v-if="resetFriendRequests.length > 0" class="badge badge-request-count">{{ resetFriendRequests.length }}</span>
        </button>
      </div>
    </div>
    <b-modal
      id="delete-confirm-modal"
      ref="deleteConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      modal-class="simple-design"
      :lazy="true"
      centered
      :no-close-on-backdrop="true"
      @ok="deleteFriend($event)"
    >
      <p v-if="targetFriend && targetFriend.sttusCode==='friend_status.requested'" class="my-4" v-html="$t('reset.confirm.cancel_friend_request')" />
      <p v-if="targetFriend && targetFriend.sttusCode==='friend_status.accepted'" class="my-4" v-html="$t('reset.confirm.delete_friend')" />
    </b-modal>
    <b-modal
      id="request-confirm-modal"
      ref="requestConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      modal-class="simple-design"
      :lazy="true"
      centered
      :no-close-on-backdrop="true"
      @ok="requestFriends($event)"
    >
      <p class="my-4" v-html="$t('reset.confirm.request_friend')" />
    </b-modal>
    <b-modal
      id="accept-confirm-modal"
      ref="acceptConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      modal-class="simple-design"
      :lazy="true"
      centered
      :no-close-on-backdrop="true"
      @ok="acceptFriends($event)"
    >
      <p class="my-4" v-html="$t('reset.confirm.accept_friend')" />
    </b-modal>
    <b-modal
      id="search-partner-modal"
      ref="searchPartnerModalRef"
      :title="$t('reset.text.request_friend')"
      modal-class="simple-design full-modal"
      :ok-only="true"
      :ok-title="$t('reset.text.request_friend')"
      :lazy="true"
      :ok-disabled="selectedPartners.length === 0"
      centered
      :no-close-on-backdrop="true"
      @ok="showRequestFriendsConfirmModal($event)"
    >
      <div class="search-control-container">
        <input v-model="searchPartnerKeyword" type="text" class="partner-search-keyword full" :placeholder="$t('column.nm.nm') + ' - ' + $t('column.nm.user_id')" @keyup="onKeyupUserKeyword($event)">
        <button class="btn no-border partner-search-button" @click="searchPartner($event)">
          {{ $t('common.button.search') }}
        </button>
      </div>
      <div v-if="selectedPartners && selectedPartners.length > 0">
        <div class="selected-partner-list-title">
          {{ $t('reset.text.selected_partner') }}
        </div>
        <div class="clear" />
        <div class="selected-partner-list-container">
          <div v-for="(partner, partnerIndex) in selectedPartners" :key="'selected-partner-' + partnerIndex" class="partner-item selected-partner-item" @click="togglePartner(partner, $event)">
            <div :class="{'partner-image':true}">
              <centered-image :cover="true" :src="getImgUrl(partner.data.thumbs)" :alt="partner.data.nm" />
            </div>
            <div class="partner-name">
              {{ partner.data.nm }}
            </div>
          </div>
        </div>
      </div>
      <div class="clear" />
      <div v-if="searchedPartners && searchedPartners.length > 0" class="searched-partner-list-container" @scroll="onScrollSearchedPartnerList">
        <div class="row searched-partner-list-wrapper">
          <div v-for="(partner, partnerIndex) in searchedPartners" :key="'searched-partner-' + partnerIndex" class="col-4 partner-item" @click="togglePartner(partner, $event)">
            <div :class="{'partner-image':true, 'selected':isSelectedPartner(partner)}">
              <centered-image :cover="true" :src="getImgUrl(partner.data.thumbs)" :alt="partner.data.nm" />
            </div>
            <div class="partner-name">
              {{ partner.data.nm }}
            </div>
            <div v-if="partner.data.usanaGradCode" class="partner-grade">
              {{ $t('code.nm.' + partner.data.usanaGradCode) }}
            </div>
            <div v-else-if="partner.data.userId.startsWith('C')" class="partner-grade">
              {{ $t('common.text.consumer') }}
            </div>
            <div v-if="partner.data.userId.startsWith('C')" class="partner-tel">
              {{ partner.data.userId }}({{ $t('common.text.coupon') }})
            </div>
            <div v-if="partner.data.mobile" class="partner-tel">
              {{ partner.data.mobile | formatKoreanTel(true) }}
            </div>
          </div>
        </div>
        <div v-if="!searchedFriendsNoMore" class="reset-friends-loading resets-loading">
          <div class="clear" />
          <img src="/img/ajax-loader-white-bg.gif" alt="Loading">
          <strong>{{ $t('common.text.loading') }}</strong>
        </div>
      </div>
      <div v-else class="searched-partner-list-container no-data">
        {{ $t('common.text.no_data') }}
      </div>
    </b-modal>
    <b-modal
      id="friend-request-modal"
      ref="friendRequestModalRef"
      :title="$t('reset.text.accept_friend')"
      modal-class="simple-design full-modal"
      :ok-only="true"
      :ok-title="$t('reset.text.accept_friend')"
      :lazy="true"
      :ok-disabled="selectedRequests.length === 0"
      centered
      :no-close-on-backdrop="true"
      @ok="showAcceptFriendsConfirmModal($event)"
    >
      <div class="searched-partner-list-container">
        <div class="row">
          <div v-for="(resetFriendRequest, resetFriendRequestIndex) in resetFriendRequests" :key="'searched-partner-' + resetFriendRequestIndex" class="col-4 partner-item" @click="toggleRequest(resetFriendRequest, $event)">
            <div :class="{'partner-image':true, 'selected':isSelectedRequest(resetFriendRequest)}">
              <centered-image :cover="true" :src="getImgUrl(resetFriendRequest.partner.thumbs)" :alt="resetFriendRequest.partner.nm" />
            </div>
            <div class="partner-name">
              {{ resetFriendRequest.partner.nm }}
            </div>
            <div v-if="resetFriendRequest.partner.usanaGradCode" class="partner-grade">
              {{ $t('code.nm.' + resetFriendRequest.partner.usanaGradCode) }}
            </div>
            <div v-if="resetFriendRequest.partner.mobile" class="partner-tel">
              {{ resetFriendRequest.partner.mobile | formatKoreanTel(true) }}
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchTextResetFriendsInput: '',
      resetFriends: undefined,
      resetFriendFirstId: undefined,
      resetFriendsOrder: 'nm',
      resetFriendsDirection: 'asc',
      resetFriendsTotal: undefined,
      resetFriendsLoaded: undefined,
      resetFriendRequests: [],
      searchedPartners: [],
      searchPartnerKeyword: '',
      targetFriend: undefined,
      selectedPartners: [],
      selectedRequests: [],
      searchedFriendsNoMore: false
    }
  },
  async mounted() {
    await this.loadResetFriends(true)
    await this.loadResetFriendsRequest()
  },
  beforeDestroy() {
    if (this.searchUserTimer) {
      clearTimeout(this.searchUserTimer)
    }
  },
  methods: {
    isSelectedPartner(partner) {
      for (let i = 0; i < this.selectedPartners.length; i++) {
        if (this.selectedPartners[i].value === partner.value) {
          return true
        }
      }
      return false
    },
    togglePartner(partner, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      for (let i = 0; i < this.selectedPartners.length; i++) {
        if (this.selectedPartners[i].value === partner.value) {
          this.selectedPartners.splice(i, 1)
          return
        }
      }
      this.selectedPartners.push(partner)
      this.$forceUpdate()
    },
    isSelectedRequest(request) {
      for (let i = 0; i < this.selectedRequests.length; i++) {
        if (this.selectedRequests[i].id === request.id) {
          return true
        }
      }
      return false
    },
    toggleRequest(request, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      for (let i = 0; i < this.selectedRequests.length; i++) {
        if (this.selectedRequests[i].id === request.id) {
          this.selectedRequests.splice(i, 1)
          return
        }
      }
      this.selectedRequests.push(request)
      this.$forceUpdate()
    },
    showRequestFriendsModal(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.searchedPartners = []
      this.searchPartnerKeyword = ''
      this.selectedPartners = []
      this.searchedPageNo = 0
      this.searchedFriendsNoMore = false
      this.$forceUpdate()
      this.vibrate(e)
      this.showModal('searchPartnerModalRef')
    },
    showAcceptFriendsModal(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.selectedRequests = []
      this.$forceUpdate()
      this.vibrate(e)
      this.showModal('friendRequestModalRef')
    },
    showRequestFriendsConfirmModal(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showModal('requestConfirmModalRef')
    },
    showAcceptFriendsConfirmModal(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showModal('acceptConfirmModalRef')
    },
    onKeyupUserKeyword(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      if (e.target.value !== undefined) {
        this.searchPartnerKeyword = e.target.value
      }
      this.vibrate(e)
      if (this.searchUserTimer) {
        clearTimeout(this.searchUserTimer)
      }
      this.searchUserTimer = setTimeout(() => {
        if (this.searchUserTimer) {
          clearTimeout(this.searchUserTimer)
          this.searchUserTimer = undefined
        }
        this.searchPartner()
      }, 300)
    },
    searchPartner(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.searchedPageNo = 0
      this.searchedFriendsNoMore = false
      this.searchPartnerProcess(true)
    },
    searchPartnerProcess(refresh) {
      this.searching = true
      const size = 15
      this.$axios
        .$get(
          '/reset/searchUsers?q=' +
            encodeURIComponent(this.searchPartnerKeyword) +
            '&withImageFlag=Y&withResetFriendFlag=N&siteId=homepage&pageNo=' +
            this.searchedPageNo +
            '&size=' +
            size
        )
        .then(response => {
          this.searching = false
          if (response.resultCode === 'success') {
            this.searchedPageNo++
            if (refresh) {
              this.searchedPartners = []
            }
            this.searchedPartners = this.searchedPartners.concat(response.data)
            if (!response.data || response.data.length !== size) {
              this.searchedFriendsNoMore = true
            }
          } else {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          }
        })
        .catch(e => {
          this.searching = false
        })
    },
    deleteFriendConfirm(friend, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.targetFriend = friend
      this.showModal('deleteConfirmModalRef')
    },
    deleteFriend(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)

      let url = '/reset/deleteFriend?id=' + this.targetFriend.id
      if (this.searchTextResetFriends) {
        url += '&searchText=' + encodeURIComponent(this.searchTextResetFriends)
      }
      this.$axios.$delete(url).then(response => {
        if (response.resultCode === 'success') {
          this.hideModal('deleteConfirmModalRef')
          this.resetFriendsTotal--
          this.resetFriendsLoaded--
          this.resetFriendFirstId = response.data.firstId
          for (let i = 0; i < this.resetFriends.length; i++) {
            if (this.resetFriends[i].id === this.targetFriend.id) {
              this.resetFriends.splice(i, 1)
              break
            }
          }
          this.$toast.info(this.$t(response.message))
          this.$forceUpdate()
        } else {
          console.error(this.$t(response.message))
          this.$toast.error(this.$t(response.message))
        }
      })
    },
    requestFriends(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)

      const url = '/reset/requestFriends'
      this.$axios.$post(url, this.selectedPartners).then(response => {
        if (response.resultCode === 'success') {
          this.selectedPartners = []
          this.hideModal('requestConfirmModalRef')
          this.hideModal('searchPartnerModalRef')
          this.$toast.info(this.$t(response.message, response.params))
          this.loadResetFriends(true)
          this.loadResetFriendsRequest()
          this.$forceUpdate()
        } else {
          console.error(this.$t(response.message))
          this.$toast.error(this.$t(response.message))
        }
      })
    },
    acceptFriends(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)

      const url = '/reset/acceptFriends'
      this.$axios.$post(url, this.selectedRequests).then(response => {
        if (response.resultCode === 'success') {
          this.selectedRequests = []
          this.hideModal('acceptConfirmModalRef')
          this.hideModal('friendRequestModalRef')
          this.$toast.info(this.$t(response.message, response.params))
          this.loadResetFriends(true)
          this.loadResetFriendsRequest()
          this.$forceUpdate()
        } else {
          console.error(this.$t(response.message))
          this.$toast.error(this.$t(response.message))
        }
      })
    },
    selectResetFriend(reset, e) {
      this.$emit('select-reset', {
        reset: reset,
        e: e
      })
    },
    searchResetFriends(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.searchTextResetFriends = this.searchTextResetFriendsInput
      this.loadResetFriends(true)
    },
    clickResetFriendsOrder(order, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (order === this.resetFriendsOrder) {
        if (this.resetFriendsDirection === 'asc') {
          this.resetFriendsDirection = 'desc'
        } else {
          this.resetFriendsDirection = 'asc'
        }
      } else {
        this.resetFriendsDirection = 'desc'
        this.resetFriendsOrder = order
      }
      this.loadResetFriends(true)
    },
    async loadResetFriendsRequest() {
      const url = '/reset/friendsRequested'
      const res = await this.$axios.$get(url)
      this.resetFriendRequests = res.data
    },
    async loadResetFriends(refresh) {
      if (refresh) {
        this.resetFriends = undefined
        this.resetFriendFirstId = undefined
        this.resetFriendsTotal = undefined
        this.resetFriendsLoaded = 0
        window.resetFriendsPage = -1
      }
      if (this.resetFriendsTotal === this.resetFriendsLoaded) {
        return
      }
      window.resetFriendsPage++
      let url = '/reset/resetFriends?pageNo=' + window.resetFriendsPage
      if (this.resetFriendFirstId) {
        url += '&firstId=' + this.resetFriendFirstId
      }
      if (this.searchTextResetFriends) {
        url += '&searchText=' + encodeURIComponent(this.searchTextResetFriends)
      }
      url +=
        '&order=' +
        encodeURIComponent(this.resetFriendsOrder) +
        '&direction=' +
        this.resetFriendsDirection
      const res = await this.$axios.$get(url)
      if (!this.resetFriends) {
        this.resetFriends = res.data.list
      } else {
        this.resetFriends = this.resetFriends.concat(res.data.list)
      }
      this.resetFriendsTotal = res.data.totalSize
      if (!this.resetFriendFirstId) {
        this.resetFriendFirstId = res.data.firstId
      }
      if (this.resetFriends) {
        this.resetFriendsLoaded = this.resetFriends.length
      }
      this.$nextTick(() => {
        this.onScrollResetFriends()
      })
    },
    getPrice(reset) {
      let amount = 0
      if (reset && reset.products) {
        for (let i = 0; i < reset.products.length; i++) {
          const productAmount = reset.products[i].co * reset.products[i].pc
          amount += productAmount
        }
      }
      return amount
    },
    onScrollSearchedPartnerList() {
      const comp =
        $('.searched-partner-list-wrapper').height() -
        $('.searched-partner-list-container').height()
      const top = $('.searched-partner-list-container').scrollTop()
      if (comp - top < 50 && !this.searching) {
        this.searchPartnerProcess()
      }
    },
    onScrollResetFriends(e) {
      const comp =
        $('.reset-friends-list-wrapper').height() -
        $('.reset-friends-list-container').height()
      const top = $('.reset-friends-list-container').scrollTop()
      if (comp - top < 50) {
        this.loadResetFriends(false)
      }
    }
  }
}
</script>

<style scoped>
.reset-friend-list {
  padding: 0;
}
.reset-friends-list-container {
  height: calc(100vh - 25.5rem);
  overflow-y: auto;
  overflow-x: hidden;
}
.search-title .fa {
  color: #360ea6;
  font-size: 1.5rem;
  margin-left: 1.708333333333333rem;
  position: absolute;
  z-index: 4;
}
.search-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.708333333333333rem;
  background: #f1f1f1;
}
.search-title {
  padding: 1rem 0;
}
.search-title >>> input[type='text']::placeholder,
.search-title >>> input[type='text'] {
  font-size: 0.95rem !important;
}
.search-title >>> input[type='text'] {
  padding: 0 0.7rem;
  padding-left: 2.6rem;
  height: 2.291666666666667rem;
}
.search-title-text {
  height: 2.291666666666667rem;
  border: none;
  margin-left: 1rem;
  width: calc(100vw - 2rem);
}
.search-title-text >>> input {
  border: none !important;
  box-shadow: none !important;
}
.resets-loading {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .input-control {
  min-height: auto;
  margin-bottom: 0;
}
.no-data {
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10rem;
}

.selectors {
  margin-bottom: 0.6rem;
  display: flex;
  justify-content: space-between;
}
.selectors > select {
  margin-right: 0.4rem;
}
.reset-friend-item {
  float: left;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.profile-image-container {
  overflow: hidden;
  margin: auto;
  border-radius: 2rem;
  background-image: url(/img/gnb/empty_profile.png);
  background-size: 100%;
  width: 3.89rem;
  height: 3.89rem;
  display: flex;
  align-items: center;
  justify-content: start;
}
.profile-image-container.no-default-image {
  background-image: none !important;
}
.partner-name-and-telno {
  width: calc(100% - 9.89rem);
  padding-left: 0.3rem;
}
select.simple-design {
  background-position: calc(100% - 0.6rem) 0.76rem, calc(100% - 0.2rem) 0.76rem,
    calc(100% - 1.3rem) 0;
  background-size: 0.416rem 0.416rem, 0.416rem 0.416rem, 1px 2.2rem;
}
.sorting-area .fa-play {
  transform: rotate(270deg);
}
.sorting-area .selected .fa-play.desc {
  transform: rotate(90deg);
}
.sorting-area {
  color: #e5e5e5;
  padding: 0 1rem;
  font-size: 0.825rem;
  margin-bottom: 1rem;
}
.sorting-area .selected {
  color: #360ea6;
}
.sort-item {
  margin-right: 1rem;
}
.sort-item .fa {
  margin-left: 0.5rem;
}
.full-text {
  width: 80vw;
}
.partner-name-and-telno {
  font-size: 0.9416rem;
  color: #363636;
}
.btn-delete-friend {
  color: white;
  font-size: 0.9166rem;
  background: #bebebe;
  line-height: 0.5rem;
  height: auto;
  padding: 0.7rem 0;
  width: 6rem;
}
.btn-delete-friend:active,
.btn-delete-friend:focus,
.btn-delete-friend:hover {
  color: white;
  outline: none !important;
  box-shadow: none !important;
}
.controls {
  position: fixed;
  left: 0;
  bottom: 4rem;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 100vw;
  justify-content: center;
  padding: 1.3166rem 1.5rem;
  background: white;
}
.controls .btn {
  background: #360ea6;
  color: white;
  border-radius: 0.558rem;
  font-size: 0.883rem;
  height: 2.358rem;
  margin: 0 0.3rem;
  width: 6.7333rem;
}
.search-control-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.partner-search-keyword {
  margin-left: 1.2rem;
  border-radius: 0.141rem;
  border: 1px solid #bebebe;
  width: 16.8rem;
  height: 2.2rem;
}
.partner-search-keyword.full {
  width: 100%;
  margin-left: 0;
}
.partner-search-keyword {
  font-size: 0.8333rem;
  padding: 0 0.5rem;
}
.partner-search-keyword::placeholder {
  font-size: 0.8333rem !important;
  color: rgba(0, 0, 0, 0.1);
}
.partner-search-button {
  margin-left: 0.6rem;
  font-size: 0.666rem;
  color: white;
  background: #360ea6;
  width: 3.458rem;
  height: 2.308rem;
}
.partner-search-button:active,
.partner-search-button:focus,
.partner-search-button:hover {
  color: white;
}
.searched-partner-list-container {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
  word-break: break-all;
  padding: 0 1rem;
  margin: 1rem 0;
}
.searched-partner-list-container.no-data {
  height: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-control-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.selected-partner-list-container {
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: auto;
  display: flex;
  max-width: 100%;
}
.selected-partner-list-container .partner-image {
  overflow: hidden;
  border-radius: 2rem;
  width: 4rem;
  height: 4rem;
  background: #ededed;
  position: relative;
}
.searched-partner-list-container .partner-image {
  overflow: hidden;
  border-radius: 2.6rem;
  width: 5.2rem;
  height: 5.2rem;
  background: #ededed;
  position: relative;
}
.searched-partner-list-container .partner-image.selected::after {
  background-color: rgba(3, 204, 200, 0.5);
  background-image: url('/img/reset/ic_check.png');
  background-size: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  content: ' ';
  width: 5.2rem;
  height: 5.2rem;
  position: absolute;
  left: 0;
  top: 0;
}

.searched-partner-list-container .partner-item {
  margin: 0 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
}
.selected-partner-list-container .partner-name,
.searched-partner-list-container .partner-name,
.searched-partner-list-container .partner-grade,
.searched-partner-list-container .partner-tel {
  font-size: 0.6rem;
  color: #363636;
  text-align: center;
}
.friend-status {
  font-size: 0.9166rem;
  text-align: center;
  color: #999999;
}
.selected-partner-list-title {
  margin-top: 0.5rem;
  font-size: 1rem;
}
.selected-partner-item {
  float: left;
  margin-right: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
}
.selected-partner-item .partner-image::after {
  background-color: rgba(3, 204, 200, 0.5);
  background-image: url('/img/reset/ic_check.png');
  background-size: 1rem;
  background-repeat: no-repeat;
  background-position: 50%;
  content: ' ';
  width: 4rem;
  height: 4rem;
  position: absolute;
  left: 0;
  top: 0;
}
.badge-request-count {
  position: absolute !important;
  top: -0.5rem !important;
  right: -0.5rem !important;
  background: red !important;
}
.reset-friends-list-wrapper {
  padding: 0 1rem;
}
</style>
